import { LabClient, QueriesClient } from "@app/api2/api";
import React from "react";
import { DropdownProps } from "@/components/bp/bp-ui";
import { useSessionItem } from "./Hooks";
import { AsyncDropdown } from "./AsyncDropdown";

interface ILabsDropdownProps {
  // storeKey?: string;
  name?: string;
  value?: any;
  onLabsLoaded?: (labs: any[]) => void;
  onChange?: (event: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => void;
  hideAllLabsOption?: boolean;
  setFieldValue?: (field: string, value: any) => Promise<void>;
  setFieldTouched?: (field: string, touched: boolean, shouldValidate?: boolean) => Promise<void>;
}

export const LabsDropdown: React.FunctionComponent<ILabsDropdownProps> = ({
  // storeKey,
  name = "labId",
  value,
  onChange,
  hideAllLabsOption,
  setFieldValue,
  setFieldTouched,
  onLabsLoaded
}) => {
  const queriesClient = new QueriesClient();

  // Use shared session state if storeKey is provided, otherwise use local state
  // const [selectedLabId, setSelectedLabId] = storeKey
  //   ? useSessionItem(storeKey)
  //   : React.useState<any>(value);

    const [selectedLabId, setSelectedLabId] = React.useState<any>(value);

  const dataSource = async () => {
    const labsResponse = await queriesClient.getAllLabs();
    const labs = labsResponse.labs.map((lab) => ({
      key: lab.id,
      value: lab.id,
      text: lab.name,
    }));
    if (!hideAllLabsOption && labs.length > 1) {
      labs.unshift({
        key: "" as any,
        value: "" as any,
        text: window.translation.lab.allLabs,
      });
    }
    return labs;
  };

  return (
    <AsyncDropdown
      selection
      clearable
      optionsChanged={onLabsLoaded}
      dataSource={dataSource}
      defaultValue={selectedLabId}
      placeholder={window.translation.lab.allLabs}
      onChange={async (event, data) => {
        setSelectedLabId(data.value);

        if (setFieldValue)
          await setFieldValue(name, data.value);

        if (setFieldTouched)
          await setFieldTouched(name, true, true);

        if (onChange)
          onChange(event, data);
      }}
    />
  );
};